export default "__VITE_ASSET__D93ZpdDN__"